import React, { useEffect, useState } from "react";

const CircularProgress = ({ value = 1, max = 2, size = 32, strokeWidth = 4, duration = 222 }) => {
    const radius = (size - strokeWidth) / 2;
    const circumference = 2 * Math.PI * radius;

    const [offset, setOffset] = useState(circumference);

    useEffect(() => {
        const progress = (value / max) * circumference;
        const newOffset = circumference - progress;

        let animationFrame;
        let start;

        const animate = (timestamp) => {
            if (!start) start = timestamp;
            const elapsed = timestamp - start;

            const progressOffset = offset + (newOffset - offset) * Math.min(elapsed / duration, 1);

            setOffset(progressOffset);

            if (elapsed < duration) {
                animationFrame = requestAnimationFrame(animate);
            }
        };

        animationFrame = requestAnimationFrame(animate);

        return () => cancelAnimationFrame(animationFrame);
    }, [value, max, circumference, duration]);

    return (
        <svg width={size} height={size} className="circular-progress">
            {/* Background Circle */}
            <circle
                cx={size / 2}
                cy={size / 2}
                r={radius}
                stroke="#e5e5e5"
                strokeWidth={strokeWidth}
                fill="none"
            />

            {/* Progress Circle */}
            <circle
                cx={size / 2}
                cy={size / 2}
                r={radius}
                stroke="#000"
                strokeWidth={strokeWidth}
                fill="none"
                strokeDasharray={circumference}
                strokeDashoffset={offset}
                strokeLinecap="round"
                transform={`rotate(-90 ${size / 2} ${size / 2})`}
            />

            {/* Text in the middle */}
            <text
                x="50%"
                y="52%"
                dominantBaseline="middle"
                textAnchor="middle"
                fontSize={size * 0.35}
                fill="#000"
            >
                {value}/{max}
            </text>
        </svg>
    );
};

export default CircularProgress;
